<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
          <div class="row">
      </div>
        </div>
      </div>
      
    </div>
    <div id="createInvoice">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            
            <h5 class="modal-title" id="exampleModalLabel">Change Invoice Status</h5><br/><br/>
            <flash-message class="myCustomClass"></flash-message>
            <button type="button" class="close" id="invoiceClose"  @click="$emit('close')" data-dismiss="modal" aria-label="Close">
              <i class="material-icons">close</i>
            </button>
          </div>
          <form>
            <div class="modal-body">
            <div class="row">
               <div class="col-md-12">
                  <div class="form-group">
                    <input type="radio" id="paid" ref="status" v-model="input.status"  name="status" value='paid' />
                    <label class="control-label">Paid </label>
                      </div>
                    <div class="form-group">
                    
                     <input type="radio" id="void" ref="status" v-model="input.status"  name="status" value='void' />
                    <label class="control-label">Void </label>
                 </div>
                  <div class="form-group">
                    <textarea class="form-control" id="description" ref="description" v-model="input.note" name="description" placeholder="Add Note">
                  </textarea>
                </div>
            </div>
           </div>
            </div>
            <div class="modal-footer">
              <button type="button" id="save" class="btn btn-primary" v-on:click="saveInvoice()">Submit</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import changeInvoiceStatus from './changeInvoiceStatus'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
require('vue-flash-message/dist/vue-flash-message.min.css')
export default {
  name: 'Invoice',
  components: { changeInvoiceStatus,
    Loading
  },
  data () {
    return {
      msg: '',
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      successMessage: '',
      errors: [],
      input: {
        status: '',
        note: ''
      },
    }
  },
  methods: { 
  
  saveInvoice () {
      var jwttoken = localStorage.getItem('jwt')
      var currentUrl = window.location.href
      console.log('invoiceid = ' + currentUrl)
      var splitUrl = currentUrl.split('/')
      var invoiceId = splitUrl[4]
      this.errors = []
      var status = this.input.status
      var note = this.input.note
      this.errors = []
        if (this.input.status === '') {
          this.errors.push('Please choose status')
          this.$refs.status.focus()
        }else{
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/changeInvoiceStatus', {
          invoice_id: invoiceId,
          status: status,
          note: note,
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            
            this.$eventBus.$emit('changeInvoiceStatus', 'Invoice status updated successfully');
            this.$eventBus.$emit('changeInvoiceStatus');
            this.$emit('close')
            this.isLoading = false
           })
            .catch((error) => {
              this.$eventBus.$emit('changeInvoiceStatus', '',error.response.data.errors);
              this.$emit('close')
              this.isLoading = false
            })
       }
      }
  },
  computed: {

  },
  mounted () {
    var jwttoken = localStorage.getItem('jwt')

  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/changeInvoiceStatus.vue